import { chakra, Checkbox as ChakraCheckbox } from '@chakra-ui/react';
import { CheckboxIndicator } from '@components/ui/checkbox/CheckboxIndicator';
import { checkmarkRecipe } from '@theme/recipes';
import { ChangeEventHandler, forwardRef, InputHTMLAttributes, ReactNode, RefObject } from 'react';

export interface CheckboxProps extends Omit<ChakraCheckbox.RootProps, 'onChange'> {
  label?: ReactNode;
  loading?: boolean;
  checkboxProps?: InputHTMLAttributes<HTMLInputElement>;
  rootRef?: RefObject<HTMLLabelElement | null>;
  onChange?: ChangeEventHandler<HTMLInputElement>;
}

const StyledCheckboxControl = chakra(ChakraCheckbox.Control, checkmarkRecipe);

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(props, ref) {
  const { label, loading, checkboxProps, rootRef, onChange, ...rest } = props;
  return (
    <ChakraCheckbox.Root height="min-content" ref={rootRef} {...rest}>
      <ChakraCheckbox.HiddenInput ref={ref} onChange={onChange} {...checkboxProps} />
      <StyledCheckboxControl className="chakra-checkmark" alignSelf="start">
        <ChakraCheckbox.Indicator>
          <CheckboxIndicator loading={loading} checked={props.checked} />
        </ChakraCheckbox.Indicator>
      </StyledCheckboxControl>
      {label && <ChakraCheckbox.Label>{label}</ChakraCheckbox.Label>}
    </ChakraCheckbox.Root>
  );
});
